import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.SignupForm.SELECT_FORM_TYPE:
      return action.payload
    case ActionType.SignupForm.RECEIVE_FORM:
      if (action.payload) {
        return 'signup'
      }
      return null
    case ActionType.CustomForm.RECEIVE_FORM:
      if (action.payload) {
        if (action.payload?.internal_type === 'ci1') {
					return 'customIntegration'
				}
        return 'custom'
      }
      return null
    default:
      return state
  }
}
